import env from "app/utils/env";
import axios from "axios";
import { FETCH_STRESS_DATA } from "app/actionTypes";

export const fetchProductStressMarketingsData = code => {
	const endpoint = env("DATA_API_URL") || env("BASE_URL");

	return {
		type: FETCH_STRESS_DATA,
		promise: axios.get(`${endpoint}/SD_V1/SD_${code}.json`),
	};
};
